module.exports = __webpack_public_path__ + "static/3-c1919ef7fb05cb4dc99b256870b10754.png";